// Angular imports
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

// Import services
import { SideMenuService } from '../../services';
import { Store } from '@ngrx/store';
import { hideSideMenu, showSideMenu } from 'src/app/state-management/calculation-actions';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { selectSideMenuOpen } from 'src/app/state-management/calculation-selectors';

@Component({
    selector: 'menu-bar',
    templateUrl: './menu-bar.component.html',
    styleUrls: ['./menu-bar.component.scss'],
    standalone: false
})
export class MenuBarComponent implements OnInit {
    @Input() public optionsActive: boolean = true;
    @Input() public activeTableLocked: boolean = false;

    @Input() public displayOptions: boolean = true;
    @Input() public displayMainOptions: boolean = true;

    constructor(private store: Store) { }

    public ngOnInit(): void {

    }

    public async _openSideMenu(event: MouseEvent): Promise<void> {
        event.stopPropagation();
        event.preventDefault();
        // Open the side menu
        const menuState = await firstValueFrom(this.store.select(selectSideMenuOpen));

        if (menuState) {
            this.store.dispatch(hideSideMenu());
        } else {
            this.store.dispatch(showSideMenu());
        }
    }
}